import { render, staticRenderFns } from "./imprimirDetailsReversa.vue?vue&type=template&id=3fe63e80&scoped=true&"
import script from "./imprimirDetailsReversa.vue?vue&type=script&lang=js&"
export * from "./imprimirDetailsReversa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe63e80",
  null
  
)

export default component.exports